import * as d3 from 'd3-selection'
import * as colors from 'colors'

const gradients = (d, i, all) => {
  return [{
    // The two overlapping gradients for the base
    id: `funnel-base-${d}-a`,
    clazz: `funnel-base funnel-base-gradient-${d}-a`,
    type: 'linearGradient',
    stops: [{
      offset: '10%',
      color: colors.adjustLightness(colors.lookup(d), 40)
    }, {
      offset: '45%',
      color: colors.adjustLightness(colors.lookup(d), 5)
    }, {
      offset: '100%',
      color: colors.adjustLightness(colors.lookup(d), -25)
    }],
    attrs: {
      x1: 0,
      x2: 1,
      y1: .4,
      y2: .6
    }
  }, {
    id: `funnel-base-${d}-b`,
    clazz: `funnel-base funnel-base-gradient-${d}-b`,
    type: 'linearGradient',
    stops: [{
      offset: '0%',
      color: colors.changeColor(colors.adjustLightness(colors.lookup(d), 60), .2)
    }, {
      offset: '50%',
      color: colors.changeColor(colors.adjustLightness(colors.lookup(d), 5), .22)
    }, {
      offset: '100%',
      color: colors.changeColor(colors.adjustLightness(colors.lookup(d), -25), .25)
    }],
    attrs: {
      x1: .5,
      x2: .5,
      y1: 0,
      y2: 1
    }
  }, {
    // The two overlapping gradients for the top "hole"
    id: `funnel-top-inner-${d}-a`,
    clazz: `funnel-top-inner funnel-top-inner-gradient-${d}-a`,
    type: 'linearGradient',
    stops: [{
      offset: '10%',
      color: colors.adjustLightness(colors.lookup(d), 20)
    }, {
      offset: '100%',
      color: colors.adjustLightness(colors.lookup(d), -15)
    }],
    attrs: {
      x1: 0,
      x2: 1,
      y1: .4,
      y2: .6
    }
  }, {
    id: `funnel-top-inner-${d}-b`,
    clazz: `funnel-top-inner funnel-top-inner-gradient-${d}-b`,
    type: 'linearGradient',
    stops: [{
      offset: '0%',
      color: colors.changeColor(colors.adjustLightness(colors.lookup(d), 60), .2)
    }, {
      offset: '100%',
      color: colors.changeColor(colors.adjustLightness(colors.lookup(d), -60), .3)
    }],
    attrs: {
      x1: .5,
      x2: .5,
      y1: 0,
      y2: 1
    }
  }, {
    // The top ring gradient
    id: `funnel-top-outer-${d}`,
    clazz: `funnel-top-outer funnel-top-outer-gradient-${d}`,
    type: 'linearGradient',
    stops: [{
      offset: '0%',
      color: colors.adjustLightness(colors.lookup(d), 60)
    }, {
      offset: '100%',
      color: colors.lookup(d)
    }],
    attrs: {
      x1: 0,
      x2: 1,
      y1: .3,
      y2: .7
    }
  }]
}

export default (selection, colors, transition) => {
  selection.each(function () {
    let container = d3.select(this)
      , group = container.selectAll('g.funnel-gradient-group')
                         .data(colors, d => d)
      , grads = group.enter()
                      .append('g')
                      .attr('class', 'funnel-gradient-group')
                      .merge(group)
                      .selectAll('.funnel-colored-gradient')
                      .data(gradients)

      , enter = grads.enter()
                     .append(d => {
                       return document.createElementNS('http://www.w3.org/2000/svg', d.type)
                     })

    enter.attr('id', d => d.id)
         .attr('class', d => `funnel-colored-gradient ${d.clazz}`)
         .attr('x1', d => d.attrs.x1)
         .attr('x2', d => d.attrs.x2)
         .attr('y1', d => d.attrs.y1)
         .attr('y2', d => d.attrs.y2)

    enter.selectAll('stop')
         .data(d => d.stops)
         .enter()
         .append('stop')
           .attr('offset', d => d.offset)
           .attr('stop-color', d => d.color)

    transition.end().then(() => {
      group.exit().remove()
    }).catch(() => {
      // interrupted transition, ignore
    })
  })
}
